import { Banknote, CreditCard, Wallet } from 'lucide-react'

export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Cash', icon: Banknote },
  { value: 'card', label: 'Card', icon: CreditCard },
  { value: 'store_credit', label: 'Store Credit', icon: Wallet },
] as const

export type PaymentMethodValue = (typeof PAYMENT_METHODS)[number]['value']
